/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import {
  Box,
  Input /* The above code is a comment in JavaScript. It is not doing anything in terms of
functionality, but it is used to provide information or explanations about the
code to other developers. */,
  Typography,
} from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: true,
    },
    taxType: {
      type: "",
      value: "thuế giá trị gia tăng (GTGT)",
      bg: true,
      // option: taxTypeOption,
    },
    from: {
      type: "",
      value: "01/02/2023",
      bg: true,
    },
    to: {
      type: "",
      value: "01/03/2023",
      bg: true,
    },
    tradeId: {
      type: "input",
      value: null,
      bg: false,
    },
    moneyRefund: {
      type: "input",
      value: null,
      bg: false,
    },
    caseRefund: {
      type: "input",
      value: null,
      bg: true,
    },
    note: {
      type: "input",
      value: null,
      bg: false,
    },
  },
];

export default function RefundTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };  

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" flexDirection={"column"} justifyContent="flex-start">
        <Typography component="label" variant="caption" fontSize={14} fontWeight="bold" mb={0.5}>
          II - Nội dung đề nghị hoàn trả khoản thu ngân sách nhà nước (NSNN):
        </Typography>
        <Typography variant="subtitle1" fontSize={13} fontStyle="normal">
          1. thông tin về khoản thu đề nghị hoàn trả
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Loại thuế
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                Kỳ đệ nghị hoàn
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mã giao dịch điện tử của hồ sơ khai thuế đề nghị hoàn
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tiền đề nghị hoàn trong kỳ(VNĐ)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Trường hợp đề nghị hoàn thuế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Ghi chú
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Từ kỳ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Đến kỳ
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (5)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (6)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (7)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (8)
              </Td>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "#ddeff3",
                    }}
                  >
                    {index + 1}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.taxType.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxType?.type !== "input" ? (
                      row.taxType.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="taxType"
                        value={row.taxType.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.from.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.from?.type !== "input" ? (
                      row.from.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="from"
                        value={row.from.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.to.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.to?.type !== "input" ? (
                      row.to.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="to"
                        value={row.to.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.tradeId.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.tradeId?.type !== "input" ? (
                      row.tradeId.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.tradeId.value}
                        name="tradeId"
                        value={row.tradeId.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.moneyRefund.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.moneyRefund?.type !== "input" ? (
                      row.moneyRefund.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.moneyRefund.value}
                        name="moneyRefund"
                        value={row.moneyRefund.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.caseRefund.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.caseRefund?.type !== "input" ? (
                      row.caseRefund.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.caseRefund.value}
                        name="caseRefund"
                        value={row.caseRefund.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.note.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.note?.type !== "input" ? (
                      row.note.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.note.value}
                        name="note"
                        value={row.note.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}

            <tr>
              <Td
                colspan="2"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng:
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    console.log(type);
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
